import { takeEvery, put } from "redux-saga/effects";
import { request } from "../../../api/Service";
import { getErrorMessage } from "../../../components/utils/errorHandler";
import { toast } from "react-toastify";
import history from "../../../router/browserrouter";
import { store } from "../../store";
export default function* watcherGetLocationsSaga() {
  yield takeEvery("LOAD_LOCATIONS", workerSaga);
}

function* workerSaga(action) {
  try {
    yield put({ type: "DISPLAY_LOADER", payload: payload });
    var payload = {};

    var formatUrl = `/api/Admin/get-Locations/${
      store.getState().persistReducer.companyId
    }`;
    yield request("get", action.payload, formatUrl).then((response) => {
      payload = response;
      console.log("🙌🙌🚀 This are the response", response);
    });
    yield put({ type: "LOCATIONS_LIST", payload: payload });
    yield request("get", payload, "api/Admin/get-countries-dropdown").then(
      (response) => {
        payload = response;
      }
    );
    yield put({ type: "COUNTRIES_DROPDOWN", payload: payload });
    yield request("get", payload, "/api/Admin/get-states").then((response) => {
      payload = response;
    });
    yield put({ type: "STATE_DROPDOWN", payload: payload });
    yield request(
      "get",
      action.payload,
      "/api/Admin/get-location-count?companyId=" +
        store.getState().persistReducer.companyId
    ).then((response) => {
      payload = response;
    });
    // var locations = payload.locations;
    formatUrl = "api/Admin/locationTypes-dropdown";
    yield request("get", action.payload, formatUrl).then((response) => {
      payload = response;
    });
    yield put({ type: "LOCATION_TYPE_DROPDOWN_LIST", payload: payload });
    yield put({ type: "DISPLAY_LOADER", payload: payload });
  } catch (e) {
    yield put({ type: "DISPLAY_LOADER", payload: payload });
    yield put({ type: "LOADING_BUTTON_SPINNER" });
    console.log("LOCATIONS-saga", e);
    console.log("locations-saga", e.response);
    const errorMessage = getErrorMessage(e.response);
    toast.error(errorMessage);
    yield put({ type: "API_ERRORED", payload: e });
  }
}
